import React from "react";
import { VStack } from "@design-system/VStack/VStack";
import { ConfirmInvoiceStatusDateModal } from "./ConfirmInvoiceStatusDateModal";

interface ReviseInvoiceModalProps {
    show: boolean;
    invoiceNumber: string;
    invoiceDate: string | null | undefined;
    // The invoice's entity period lock date, so the void date this modal
    // collects (revise voids the original invoice) can't land in a locked
    // period either.
    lockDate?: Date | null;
    // False while the entity period lock query is still loading — keeps Create
    // revision disabled until the lock date is known, so a void date inside a
    // locked period can't slip through during that window.
    isLockResolved?: boolean;
    // Disables Create revision while the revise orchestration is running.
    isProcessing: boolean;
    // Disables Create revision while preview / suggested number / ledgers load.
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: (voidDate: string) => void;
}

export const ReviseInvoiceModal: React.FC<ReviseInvoiceModalProps> = ({
    show,
    invoiceNumber,
    invoiceDate,
    lockDate,
    isLockResolved,
    isProcessing,
    isLoading,
    onCancel,
    onConfirm,
}) => (
    <ConfirmInvoiceStatusDateModal
        show={show}
        title={`Revise invoice ${invoiceNumber}?`}
        dateFieldLabel="Void date"
        confirmLabel="Create revision"
        minDate={invoiceDate ?? undefined}
        invoiceDate={invoiceDate}
        lockDate={lockDate}
        isLockResolved={isLockResolved}
        isProcessing={isProcessing || isLoading}
        question={
            <VStack gap={16}>
                <p>Once an invoice is opened, it can't be edited directly.</p>
                <p>
                    Revising creates a new invoice with your changes and voids
                    the original ({invoiceNumber}).
                </p>
            </VStack>
        }
        onCancel={onCancel}
        onConfirm={onConfirm}
    />
);
